import * as React from "react";
import {
  Button, TextField,
  FormControl, InputLabel, Select, MenuItem,
  Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  Box
} from "../../components/mui";
import {
  SearchRoundedIcon, RestartAltRoundedIcon, GetAppRoundedIcon, DirectionsWalkRoundedIcon
} from "../../components/icons";

import "../../styles/main.css";
import "../../styles/pages/stayOutHistory.css";
import PageLayout from "../../components/shared/PageLayout";
import PageHeader from "../../components/shared/PageHeader";
import DataTableCard from "../../components/shared/DataTableCard";

// Hardcoded filter options - Backend developer will replace with API calls
const FILTER_OPTIONS = {
  year: [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
    { value: "2022", label: "2022" },
    { value: "2021", label: "2021" },
    { value: "2020", label: "2020" }
  ],
  month: [
    { value: "all", label: "All" },
    { value: "january", label: "January" },
    { value: "february", label: "February" },
    { value: "march", label: "March" },
    { value: "april", label: "April" },
    { value: "may", label: "May" },
    { value: "june", label: "June" },
    { value: "july", label: "July" },
    { value: "august", label: "August" },
    { value: "september", label: "September" },
    { value: "october", label: "October" },
    { value: "november", label: "November" },
    { value: "december", label: "December" }
  ],
  company: [
    { value: "all", label: "All" },
    { value: "avantico-carp", label: "Avantico Carp" },
    { value: "caspo-inc", label: "Caspo Inc" }
  ]
};

// Hardcoded stay-out history data - Backend developer will replace with API calls
const STAY_OUT_HISTORY_DATA = [
  {
    id: 1,
    eid: "020",
    fullName: "Cleo",
    nickname: "Cleo",
    gender: "F",
    ranking: "2",
    designation: "Director",
    company: "Avantico Carp",
    division: "Management",
    department: "[101] Management",
    team: "Management",
    nationality: "Singaporean",
    onBoardDate: "10/10/2006",
    lastDorm: "01/09/2013"
  },
  {
    id: 2,
    eid: "021",
    fullName: "Jess",
    nickname: "Jess",
    gender: "F",
    ranking: "2",
    designation: "Director",
    company: "Avantico Carp",
    division: "Management",
    department: "[101] Management",
    team: "Management",
    nationality: "Malaysian",
    onBoardDate: "01/12/2006",
    lastDorm: "01/09/2013"
  },
  {
    id: 3,
    eid: "045",
    fullName: "Tony",
    nickname: "Tony",
    gender: "F",
    ranking: "8",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[423] Marketing (KH)",
    team: "SEA Cambodia",
    nationality: "Cambodian",
    onBoardDate: "16/09/2007",
    lastDorm: "01/03/2018"
  },
  {
    id: 4,
    eid: "048",
    fullName: "Jolina",
    nickname: "Jolina",
    gender: "F",
    ranking: "5",
    designation: "Assistant Manager",
    company: "Avantico Carp",
    division: "Product & Innovation",
    department: "[408] Product",
    team: "Product Management & Marketing",
    nationality: "Taiwanese",
    onBoardDate: "22/10/2007",
    lastDorm: "02/10/2014"
  },
  {
    id: 5,
    eid: "051",
    fullName: "Tina",
    nickname: "Tina",
    gender: "F",
    ranking: "5",
    designation: "Assistant Manager",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[401] Marketing (CN)",
    team: "EA China",
    nationality: "Taiwanese",
    onBoardDate: "04/01/2008",
    lastDorm: "26/07/2014"
  },
  {
    id: 6,
    eid: "052",
    fullName: "Joy",
    nickname: "Joy",
    gender: "F",
    ranking: "7",
    designation: "Supervisor",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "SEA Thai/Cambodian Team 2",
    nationality: "Thai",
    onBoardDate: "01/02/2008",
    lastDorm: "24/09/2018"
  },
  {
    id: 7,
    eid: "056",
    fullName: "Kris",
    nickname: "Kris",
    gender: "M",
    ranking: "8",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[401] Marketing (TH)",
    team: "SEA Thailand",
    nationality: "Thai",
    onBoardDate: "06/03/2008",
    lastDorm: "03/02/2019"
  },
  {
    id: 8,
    eid: "064",
    fullName: "Kitty",
    nickname: "Kitty",
    gender: "F",
    ranking: "7",
    designation: "Supervisor",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[401] Marketing (CN)",
    team: "EA China",
    nationality: "Taiwanese",
    onBoardDate: "14/04/2008",
    lastDorm: "02/10/2014"
  },
  {
    id: 9,
    eid: "081",
    fullName: "Noon",
    nickname: "Noon",
    gender: "F",
    ranking: "6",
    designation: "Specialist",
    company: "Avantico Carp",
    division: "Risk & Assurance",
    department: "[410] Compliance Risk",
    team: "Compliance & Control",
    nationality: "Cambodian",
    onBoardDate: "21/07/2008",
    lastDorm: "01/01/2018"
  },
  {
    id: 10,
    eid: "J000",
    fullName: "Paris",
    nickname: "Paris",
    gender: "F",
    ranking: "10",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "SEA Thai/Cambodian Team 2",
    nationality: "Thai",
    onBoardDate: "04/09/2017",
    lastDorm: "01/01/2018"
  },
  {
    id: 11,
    eid: "J002",
    fullName: "Ivan",
    nickname: "Ivan",
    gender: "M",
    ranking: "9",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "ACX",
    nationality: "Indonesian",
    onBoardDate: "04/09/2017",
    lastDorm: "04/09/2017"
  },
  {
    id: 12,
    eid: "J014",
    fullName: "Leo",
    nickname: "Leo",
    gender: "M",
    ranking: "9",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[157] Marketing",
    team: "Sponsorship",
    nationality: "Indonesian",
    onBoardDate: "09/10/2017",
    lastDorm: "09/10/2017"
  },
  {
    id: 13,
    eid: "J015",
    fullName: "Andrew",
    nickname: "Andrew",
    gender: "M",
    ranking: "6",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Human Resources",
    department: "[102] Human Resources",
    team: "Center of Excellence",
    nationality: "Taiwanese",
    onBoardDate: "09/10/2017",
    lastDorm: "13/01/2018"
  },
  {
    id: 14,
    eid: "J021",
    fullName: "Ian",
    nickname: "Ian",
    gender: "M",
    ranking: "9",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Risk & Assurance",
    department: "[413] Know Your Customer",
    team: "KYC Assurance",
    nationality: "Chinese",
    onBoardDate: "09/10/2017",
    lastDorm: "07/11/2017"
  },
  {
    id: 15,
    eid: "J030",
    fullName: "Nabin",
    nickname: "Nabin",
    gender: "M",
    ranking: "11",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[401] Marketing (CN)",
    team: "EA China",
    nationality: "Chinese",
    onBoardDate: "06/11/2017",
    lastDorm: "27/02/2019"
  }
];

function StayOutHistorySelectFilter({ label, optionKey, value, onChange }) {
  const options = FILTER_OPTIONS[optionKey] || [];

  return (
    <FormControl size="small" className="stay-out-filter">
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

function StayOutHistoryFilterActions({ onReset }) {
  return (
    <Box className="stay-out-toolbar stay-out-toolbar--filters">
      <Button variant="contained" startIcon={<SearchRoundedIcon />}>
        Search
      </Button>
      <Button variant="outlined" startIcon={<RestartAltRoundedIcon />} onClick={onReset}>
        Reset
      </Button>
      <Button variant="outlined" startIcon={<GetAppRoundedIcon />}>
        Export
      </Button>
    </Box>
  );
}

/**
 * Staff Stay-out History Page Component
 * UI/Layout only - Backend developer will add:
 * - API calls for fetching stay-out history data
 * - Filter functionality
 * - Search functionality
 * - Pagination logic
 * - Export functionality
 */
export default function StayOutHistory({ onLogout, onNavigate }) {
  // Filter state
  const [filters, setFilters] = React.useState({
    year: "2026",
    month: "all",
    company: "all"
  });

  const handleFilterChange = (field) => (event) => {
    setFilters({
      ...filters,
      [field]: event.target.value
    });
  };

  const handleReset = () => {
    setFilters({
      year: "2026",
      month: "all",
      company: "all"
    });
  };

  return (
    <PageLayout activeKey="stay-out-history" onLogout={onLogout} onNavigate={onNavigate} className="page-content">
      <PageHeader
        icon={DirectionsWalkRoundedIcon}
        title="Staff Stay-out History"
        summary="View and track all staff stay-out history records."
      />

      {/* Filters */}
      <Box className="content-box stay-out-filters">
        <Box className="stay-out-filters-row">
          <StayOutHistorySelectFilter 
            label="Year" 
            optionKey="year" 
            value={filters.year}
            onChange={handleFilterChange("year")}
          />
          <StayOutHistorySelectFilter 
            label="Month" 
            optionKey="month" 
            value={filters.month}
            onChange={handleFilterChange("month")}
          />
          <StayOutHistorySelectFilter 
            label="Company" 
            optionKey="company" 
            value={filters.company}
            onChange={handleFilterChange("company")}
          />
          <Box className="stay-out-button-group">
            <Button variant="contained" startIcon={<SearchRoundedIcon />}>
              Search
            </Button>
            <Button variant="outlined" startIcon={<RestartAltRoundedIcon />} onClick={handleReset}>
              Reset
            </Button>
            <Button variant="outlined" startIcon={<GetAppRoundedIcon />}>
              Export
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Data Table */}
      <DataTableCard
        title="Stay-out History Records"
        showExport={false}
        totalEntries={STAY_OUT_HISTORY_DATA.length}
        startEntry={1}
        endEntry={STAY_OUT_HISTORY_DATA.length}
        currentPage={1}
        totalPages={1}
      >
        <TableContainer className="data-table-wrapper">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>EID</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Nickname</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Ranking</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Division</TableCell>
                <TableCell>Department</TableCell>
                <TableCell>Team</TableCell>
                <TableCell>Nationality</TableCell>
                <TableCell>On Board Date</TableCell>
                <TableCell>Last Dorm</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {STAY_OUT_HISTORY_DATA.map((record) => (
                <TableRow hover key={record.id}>
                  <TableCell>{record.eid}</TableCell>
                  <TableCell>{record.fullName}</TableCell>
                  <TableCell>{record.nickname}</TableCell>
                  <TableCell>{record.gender}</TableCell>
                  <TableCell>{record.ranking}</TableCell>
                  <TableCell>{record.designation}</TableCell>
                  <TableCell>{record.company}</TableCell>
                  <TableCell>{record.division}</TableCell>
                  <TableCell>{record.department}</TableCell>
                  <TableCell>{record.team}</TableCell>
                  <TableCell>{record.nationality}</TableCell>
                  <TableCell>{record.onBoardDate}</TableCell>
                  <TableCell>{record.lastDorm}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DataTableCard>
    </PageLayout>
  );
}
